import { useForm } from 'react-hook-form';
import axios from 'axios';
import React, { useRef, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import GoogleMap from 'google-maps-react-markers';
import useApiUrl from '../../framework/hooks/useApiUrlHook';
import mapOptions from './MapOptions.json';
import Marker from './Marker';

export default function HotspotsMap({ hotspots, location }) {
    const mapRef = useRef(null);
    const [mapReady, setMapReady] = useState(false);

    const onGoogleApiLoaded = ({ map, maps }) => {
        mapRef.current = map;
        setMapReady(true);

        const bounds = new window.google.maps.LatLngBounds();

        hotspots.forEach(({ lat, lon, titel }) => {
            if (!isNaN(parseFloat(lat)) && !isNaN(parseFloat(lon))) {
                bounds.extend({
                    lat: parseFloat(lat),
                    lng: parseFloat(lon),
                });
            }
        });

        map.fitBounds(bounds);
    };

    if (!hotspots) return null;

    // console.log(hotspots)

    return (
        <GoogleMap
            apiKey={process.env.MIX_REACT_APP_MAPS_KEY}
            defaultCenter={{ lat: 45.4046987, lng: 12.2472504 }}
            defaultZoom={5}
            options={mapOptions}
            mapMinHeight="500px"
            onGoogleApiLoaded={onGoogleApiLoaded}
            // onChange={(map) => console.log('Map moved', map)}
        >
            {hotspots?.map(
                ({ lat, lon, titel, url }, index) =>
                    !isNaN(parseFloat(lat)) &&
                    !isNaN(parseFloat(lon)) && (
                        <Marker
                            key={index}
                            lat={parseFloat(lat)}
                            lng={parseFloat(lon)}
                            href={`/hotspots/${location}/${url}`}
                            markerId={titel} /* onClick={onMarkerClick} */
                        />
                        // <a></a>
                    ),
            )}
        </GoogleMap>
    );
}
